// SharedUI.jsx — all option shapes support { id, label, score } OR plain string
import React from 'react';
import styles from '../../styles/assessments.module.css';
import { useNavigate } from 'react-router-dom';

// ─── helpers ─────────────────────────────────────────────
// Normalise an option that may be { id, label, score } or a plain string
const optLabel = (opt) => (typeof opt === 'object' ? opt.label : opt);
const optId = (opt) => (typeof opt === 'object' ? (opt.id ?? opt.label) : opt);

// ─── Icons ────────────────────────────────────────────────
export const ChevronRight = () => (
  <svg fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24" width={16} height={16}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
);
export const ChevronLeft = () => (
  <svg fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24" width={16} height={16}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  </svg>
);
export const Check = () => (
  <svg fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24" width={10} height={10}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);
export const LockIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" width={12} height={12}>
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);
export const ChatIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" width={12} height={12}>
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
  </svg>
);

// ─── Logo ────────────────────────────────────────────────
export const Logo = () => (
  <div className={styles.logo}>
    <img src="/Home/FemCareLogo.svg" alt="femcare" className={styles.logoImg} />
  </div>
);

// ─── Screen Header ────────────────────────────────────────
export const ScreenHeader = ({ onExit }) => (
  <div className={styles.screenHeader}>
    <Logo />
    <button className={styles.exitBtn} onClick={onExit}>Save &amp; Exit</button>
  </div>
);
export const LogoScreenHeader=()=>(
  <div className={styles.screenHeader} style={{ marginBottom: "1rem", padding: 0 }} >
    <Logo />
    </div>
)
export const ScreenHeaderDFO = ({ onExit }) => {
  const navigate = useNavigate();
  return (<div className={styles.screenHeader} style={{ marginBottom: "1rem", padding: 0 }}>
    <Logo />
    <button 
    
    className={`ava-text-body    `}
    // onClick={onExit}
    onClick={()=>navigate('/')}
    >Save &amp; Exit</button>
  </div>
  );
}


// ─── Progress Bar ─────────────────────────────────────────
// export const ProgressBar = ({ step, total }) => {
//   const pct = Math.round((step / total) * 100);
//   return (
//     <div className={styles.progressWrap}>
//       <div className={styles.progressBar}>
//         <div className={styles.progressFill} style={{ width: `${pct}%` }} />
//       </div>
//       <div className={styles.progressMeta}>
//         <span className={styles.progressStep}>Step {step} of {total}</span>
//         <span className={styles.stepPct}>{pct}%</span>
//       </div>
//     </div>
//   );
// };
export const ProgressBar = ({ step, total }) => {

  const pct = Math.round(((step - 1) / total) * 100);

  return (
    <div className={styles.progressWrap}>

      <div className={styles.progressBar}>

        <div
          className={styles.progressFill}
          style={{ width: `${pct}%` }}
        />

      </div>

      <div className={styles.progressMeta}>

        <span className={styles.progressStep}>
          Question {step} of {total}
        </span>

        <span className={styles.stepPct}>
          {pct}%
        </span>

      </div>

    </div>
  );
};

// ─── Screen Footer ────────────────────────────────────────
export const ScreenFooter = ({ onBack, onNext, nextLabel = 'Next', disabled = false }) => (
  <div className={styles.screenFooter}>
    <div className={styles.footerNav}>
      <button className={styles.navBack} onClick={onBack}>
        <ChevronLeft /> Back
      </button>
      <button className={styles.navNext} onClick={onNext} disabled={disabled}>
        {nextLabel} <ChevronRight />
      </button>
    </div>
    {/* <div className={styles.footerPrivacy}>
      <span className={styles.footerPrivacyItem}><LockIcon /><span>Your information is secure and confidential</span></span>
      <span className={styles.footerPrivacyItem}><ChatIcon /><span><strong>Need help?</strong> Chat with our care team</span></span>
    </div> */}
  </div>
);

// ─── Toggle Group ─────────────────────────────────────────
// Stores opt.label as value (matches score lookup which also uses label)
export const ToggleGroup = ({ options, value, onChange }) => (
  <div className={styles.toggleGroup}>
    {options.map((opt) => {
      const label = optLabel(opt);
      const selected = value === label;
      return (
        <button
          key={optId(opt)}
          className={`${styles.toggleBtn} ${selected ? styles.toggleBtnSelected : ''}`}
          onClick={() => onChange(label)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

// ─── Age Chips ────────────────────────────────────────────
export const AgeChips = ({ options, value, onChange }) => (
  <div className={styles.persona2AgeRow}>
    {options.map((opt) => {
      const label = optLabel(opt);
      const selected = value === label;
      return (
        <button
          key={optId(opt)}
          type="button"
          className={selected ? styles.persona2ChipActive : styles.persona2Chip}
          onClick={() => onChange(label)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

// ─── Slider ───────────────────────────────────────────────
export const Slider = ({ value, onChange, min = 0, max = 10, step = 1, unit, leftLabel = 'Low', rightLabel = 'High', formatValue }) => {
  const pct = ((value - min) / (max - min)) * 100;
  const display = formatValue ? formatValue(value) : (unit ? `${value} ${unit}` : value);
  return (
    <div className={styles.sliderWrap}>
      <div className={styles.sliderLabels}>
        <span className={styles.sliderLabel}>{leftLabel}</span>
        <div className={styles.sliderTrackWrap}>
          <div className={styles.sliderValue} style={{ left: `${pct}%` }}>{display}</div>
          <input
            type="range"
            className={styles.slider}
            min={min} max={max} step={step} value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            style={{ background: `linear-gradient(to right, #5B21B6 0%, #5B21B6 ${pct}%, #DDD6FE ${pct}%, #DDD6FE 100%)` }}
          />
        </div>
        <span className={styles.sliderLabel}>{rightLabel}</span>
      </div>
      <div className={styles.sliderLabelRow}>
        <span className={styles.sliderLabel}>{leftLabel}</span>
        <span className={styles.sliderLabel}>{rightLabel}</span>
      </div>
    </div>
  );
};

// ─── Multi Chip Select ────────────────────────────────────
export const MultiChipSelect = ({ options, selected = [], onChange, noneValue }) => {
  const toggle = (opt) => {
    const label = optLabel(opt);
    if (label === noneValue) { onChange([noneValue]); return; }
    const filtered = selected.filter((x) => x !== noneValue);
    if (filtered.includes(label)) onChange(filtered.filter((x) => x !== label));
    else onChange([...filtered, label]);
  };
  return (
    <div className={styles.chipGrid}>
      {options.map((opt) => {
        const label = optLabel(opt);
        const sel = selected.includes(label);
        return (
          <button
            key={optId(opt)}
            type="button"
            className={`${styles.toggleBtn} ${sel ? styles.toggleBtnSelected : ''}`}
            onClick={() => toggle(opt)}
          >
            {/* {sel && <span className={styles.chipCheck}><Check /></span>} */}
            {label}
          </button>
        );
      })}
    </div>
  );
};

// ─── Icon Option Group ────────────────────────────────────
export const IconOptionGroup = ({ options, value, onChange }) => (
  <div className={styles.iconOptionGroup}>
    {options.map((opt) => {
      const label = optLabel(opt);
      const selected = value === label;
      return (
        <button
          key={optId(opt)}
          className={`${styles.iconOption} ${selected ? styles.iconOptionSelected : ''}`}
          onClick={() => onChange(label)}
        >
          <div className={styles.iconOptionIcon}>
            <span style={{ fontSize: 22 }}>{opt.icon}</span>
          </div>
          <span className={styles.iconOptionLabel}>{label}</span>
          {opt.sub && <span className={styles.iconOptionSub}>{opt.sub}</span>}
        </button>
      );
    })}
  </div>
);

// ─── Emoji Group ──────────────────────────────────────────
export const EmojiGroup = ({ options, value, onChange }) => (
  <div className={styles.emojiGroup}>
    {options.map((opt) => {
      const label = optLabel(opt);
      const selected = value === label;
      return (
        <button
          key={optId(opt)}
          className={`${styles.emojiOption} ${selected ? styles.emojiOptionSelected : ''}`}
          onClick={() => onChange(label)}
        >
          <div className={styles.emojiCircle} style={{ fontSize: selected ? 22 : 20 }}>{opt.emoji}</div>
          <span className={styles.emojiLabel}>{label}</span>
        </button>
      );
    })}
  </div>
);

// ─── QOL Options ─────────────────────────────────────────
export const QOLGroup = ({ options, value, onChange }) => (
  <div className={styles.qolGrid}>
    {options.map((opt) => {
      const label = optLabel(opt);
      const selected = value === label;
      return (
        <button
          key={optId(opt)}
          className={`${styles.qolOption} ${selected ? styles.qolOptionSelected : ''}`}
          onClick={() => onChange(label)}
        >
          <span className={styles.qolEmoji}>{opt.emoji}</span>
          <span className={styles.qolLabel}>{label}</span>
          {opt.num !== undefined && <span className={styles.qolNum}>{opt.num}</span>}
        </button>
      );
    })}
  </div>
);

// ─── Three Option Group ───────────────────────────────────
export const ThreeOptionGroup = ({ options, value, onChange }) => (
  <div className={styles.threeOptions}>
    {options.map((opt) => {
      const label = optLabel(opt);
      const selected = value === label;
      return (
        <button
          key={optId(opt)}
          className={`${styles.toggleBtn} ${selected ? styles.toggleBtnSelected : ''}`}
          onClick={() => onChange(label)}
        >
          {/* {selected && (
            <span className={styles.threeOptionDot}><Check /></span>
          )} */}
          {label}
        </button>
      );
    })}
  </div>
);

// ─── Red Flag Alert ───────────────────────────────────────
export const RedFlagAlert = () => (
  <div className={styles.redFlagAlert}>
    <svg className={styles.redFlagIcon} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
    </svg>
    <p className={styles.redFlagText}>
      <strong>If you answered Yes to any red flag question</strong>, please contact a doctor or go to a hospital immediately.
    </p>
  </div>
);

// ─── Number Input ─────────────────────────────────────────
export const NumberInput = ({ value, onChange, placeholder, unit }) => (
  <div className={styles.inputUnit}>
    <input
      className={styles.input}
      type="number"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
    {unit && <span className={styles.unitLabel}>{unit}</span>}
  </div>
);
